export const ID_TOKEN = 'id_token';
export const ACCESS_TOKEN = 'access_token';
export const EXPIRES_AT = 'expires_at';
export const RETURN_URL = 'return_url';
export const USER_INFO = 'user_info';
export const DEFAULT_RETURN_URL: string[] = [''];
export const DEFAULT_RETURN_URL_EXTERNAL_USER: string[] = ['orders', 'list'];
export const DEFAULT_RETURN_URL_INTERNAL_USER: string[] = ['clients', 'list'];
export const CUSTOM_CLAIMS_NAMESPACE = 'https://storever.com/';
export const CUSTOM_CLAIMS_NAME = CUSTOM_CLAIMS_NAMESPACE + 'name';
export const CUSTOM_CLAIMS_DEFAULT_CLIENT_ID = CUSTOM_CLAIMS_NAMESPACE + 'default_client_uuid';
export const CUSTOM_CLAIMS_IS_STOREVER = CUSTOM_CLAIMS_NAMESPACE + 'is_storever';
export const CUSTOM_CLAIMS_USER_UUID = CUSTOM_CLAIMS_NAMESPACE + 'user_uuid';
export const IMPERSONATION_TOKEN = 'impersonation_token';
export const IMPERSONATION_DURATION = 20 * 60; // 20 minutes in seconds
export const MANAGEMENT_API_TOKEN = 'management_api_token';
export const DEFAULT_PAGE_SIZE = 10;
export const SCROLL_OFFSET = 300;
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
export const BACKGROUND_XHR_PARAM = 'z47uiTo-gz-lygIvB8-UaU07tHU19Q27';
export const IP_PATTERN = '\\s?(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\s?';
export const EMAIL_PATTERN = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,9}$';
export const NUMERIC_PATTERN = '^\\-?(\\d+\\.?\\d*|\\d*\\.?\\d+)$';
export const NUMERIC_POSITIVE_PATTERN = '^(0|[1-9][0-9]*)$';
export const NUMERIC_POSITIVE_PATTERN_WITH_DOT = '^[0-9]+(\\.[0-9]+)?$';
export const NUMERIC_POSITIVE_PATTERN_WITH_DOT_0_TO_100 = '^(100(\\.0{1,2})?|[1-9]?\\d(\\.\\d{1,2})?)$';
export const NUMERIC_POSITIVE_FLOAT_PATTERN = '^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$';
export const TIME_PATTERN = '^$|^(([01][0-9])|(2[0-3])):[0-5][0-9]$';
export const PHONE_NUMBER_PATTERN = '^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[()-\\s\\./0-9]*$';
export const NOT_INVALID_DATE_STRING_PATTERN = '^([12]\\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01]))$';
export const SHOW_DEBUG = false;
export const BO_SETUP = 'BO_SETUP';
export const BO_ORDER = 'BO_ORDER';
export const BO_ORDERCANCEL_PICKED = 'BO_ORDERCANCEL_PICKED';
export const SEPARATOR_SELECT = '____________________________________';
export const ACCOUNT_NUMBER = '271569280';
export const DEPART_COUNTRY_CODE = 'BE';
export const DEPART_CITY = 'brussels';




